import {
    FETCH_INGRESOS_SUCCESS,
    FETCH_INGRESOS_FAILURE,
    FETCH_INGRESO_SUCCESS,
    FETCH_INGRESO_FAILURE,
    CREATE_INGRESO_SUCCESS,
    CREATE_INGRESO_FAILURE,
    UPDATE_INGRESO_SUCCESS,
    UPDATE_INGRESO_FAILURE,
    DELETE_INGRESO_SUCCESS,
    DELETE_INGRESO_FAILURE,
  } from '../actions/ingresoActions';
  
  const initialState = {
    ingresos: [],
    currentIngreso: null,
    error: null,
  };
  
  const ingresoReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_INGRESOS_SUCCESS:
        return { ...state, ingresos: action.payload, error: null };
      case FETCH_INGRESO_SUCCESS:
        return { ...state, currentIngreso: action.payload, error: null };
      case CREATE_INGRESO_SUCCESS:
        return { ...state, ingresos: [...state.ingresos, action.payload], error: null };
      case UPDATE_INGRESO_SUCCESS:
        return {
          ...state,
          ingresos: state.ingresos.map(ingreso =>
            ingreso.nrorec === action.payload.nrorec ? action.payload : ingreso
          ),
          currentIngreso: action.payload,
          error: null,
        };
      case DELETE_INGRESO_SUCCESS:
        return {
          ...state,
          ingresos: state.ingresos.filter(ingreso => ingreso.nrorec !== action.payload),
          error: null,
        };
      case FETCH_INGRESOS_FAILURE:
      case FETCH_INGRESO_FAILURE:
      case CREATE_INGRESO_FAILURE:
      case UPDATE_INGRESO_FAILURE:
      case DELETE_INGRESO_FAILURE:
        return { ...state, error: action.payload };
      default:
        return state;
    }
  };
  
  export default ingresoReducer;